<template>
  <div>
    <p class="mb-2">{{$t('printers.modal.cancellationReason.title')}}</p>
    <b-container class="mb-2">
      <b-row>
        <b-col>
          <b-form-group :label="$t('printers.modal.cancellationReason.hardwareIssues')">
            <b-form-checkbox-group
                v-model="hardwareIssueSelected"
                :options="hardwareIssueOptions"
            ></b-form-checkbox-group>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="$t('printers.modal.cancellationReason.slicerIssues')">
            <b-form-checkbox-group
                v-model="slicerIssueSelected"
                :options="slicerIssueOptions"
            ></b-form-checkbox-group>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="$t('printers.modal.cancellationReason.designIssues')">
            <b-form-checkbox-group
                v-model="designIssueSelected"
                :options="designIssueOptions"
            ></b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <b-form-group class="mb-2" :label="$t('printers.modal.cancellationReason.describeProblemMore')">
      <b-form-textarea
          v-model="details"
          rows="3"
          style="width: 100%;"
      ></b-form-textarea>
    </b-form-group>

    <div>
      <b-form-checkbox v-model="sendMail">
        {{$t('printers.modal.cancellationReason.notifyJobOwner')}}
      </b-form-checkbox>
    </div>
  </div>
</template>

<script>
  import {mapActions} from "vuex";

  export default {
    name: 'cancellation-reason',
    props: {
      jobId: {
        type: [Number, String],
        required: true
      }
    },
    data() {
      return {
        details: '',
        sendMail: true,
        hardwareIssueOptions: [
          {text: this.$t('printers.modal.cancellationReason.reasons.nozzleClogged'), value: 'Nozzle clogged'},
          {text: this.$t('printers.modal.cancellationReason.reasons.bedCalibration'), value: 'Bad calibration'},
          {text: this.$t('printers.modal.cancellationReason.reasons.notSticking'), value: 'First layer not sticking'},
          {text: this.$t('printers.modal.cancellationReason.reasons.underextrusion'), value: 'Underextrusion'},
          {text: this.$t('printers.modal.cancellationReason.reasons.mechanical'), value: 'Mechanical part mulfunction'},
          {text: this.$t('printers.modal.cancellationReason.reasons.electrical'), value: 'Electrical part mulfunction'},
          {text: this.$t('printers.modal.cancellationReason.reasons.firmwareIssue'), value: 'Firmware issue'},
          {text: this.$t('printers.modal.cancellationReason.reasons.filamentLack'), value: 'Lack of fillament'}
        ],
        hardwareIssueSelected: [],

        slicerIssueOptions: [
          {text: this.$t('printers.modal.cancellationReason.reasons.slicerSettings'), value: 'Wrong slicer settings'},
          {text: this.$t('printers.modal.cancellationReason.reasons.slicingQuality'), value: 'Bad quality slicing'},
          {text: this.$t('printers.modal.cancellationReason.reasons.printingSpeed'), value: 'Wrong printing speed'},
          {text: this.$t('printers.modal.cancellationReason.reasons.printingTemperature'), value: 'Wrong printing temperature'}
        ],
        slicerIssueSelected: [],

        designIssueOptions: [
          {text: this.$t('printers.modal.cancellationReason.reasons.position'), value: 'Wrong position on a build tray'},
          {text: this.$t('printers.modal.cancellationReason.reasons.file'), value: 'Wrong file'},
          {text: this.$t('printers.modal.cancellationReason.reasons.dontNeed'), value: 'Don\'t need this print anymore'},
          {text: this.$t('printers.modal.cancellationReason.reasons.anotherPrint'), value: 'Another high priority print'},
          {text: this.$t('printers.modal.cancellationReason.reasons.size'), value: 'The design is too large/small'}
        ],
        designIssueSelected: []
      }
    },
    methods: {
      ...mapActions(['setJobCancelReason']),

      handleSetCancelReason() {
        let request = {
          'job_id': this.jobId,
          'reason[details]': this.details,
          'send_mail': this.send_mail
        };
        for (let i in this.hardwareIssueSelected) {
          request['reason[reasons][3D printer hardware issues:][]'] = this.hardwareIssueSelected[i];
        }
        for (let i in this.slicerIssueSelected) {
          request['reason[reasons][Slicer issues:][]'] = this.slicerIssueSelected[i];
        }
        for (let i in this.designIssueSelected) {
          request['reason[reasons][Design file / job issues:][]'] = this.designIssueSelected[i];
        }
        this.setJobCancelReason(request);
      }
    }
  }
</script>